import { EventDetailModel } from './event.detail.model';

export class PagedEventDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: EventDetailModel[] = [];
}
